import React, { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

const SearchResult = props => {
  const node = useRef();
  let { exercies, handleSelectResult, setModalOpen, showResults, handleShowResults } = props;

  const handleClick = event => {
    if(node && node.current.contains(event.target)) {
      return;
    }
    handleShowResults(false);
  }

  useEffect(() => {
    // add when mounted
    document.addEventListener("mousedown", handleClick);
    // return function to be called when unmounted
    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, [handleClick]);


  return (
    <div className="search-result-list">
      <div ref={node}>
        {showResults &&
          (<ul>
            {exercies && exercies.map(exercise => {
              return(
                <li key={exercise.id}>
                  <Link href="javascript:;" onClick={e => handleSelectResult(exercise)}>{exercise.name}</Link>
                </li>
              );
            })}
            <li>
              <button
                className="btn btn-primary btn-block create-ex-btn"
                onClick={() => setModalOpen(true)}
                type="button"
                title="Create New Exercise"
              >
                Create New Exercise
              </button>
            </li>
          </ul>)
        }
        </div>
    </div>
  );
}

export default SearchResult;
